import * as React from "react";
const IconTextAlignJustifyCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M3 6.7h58c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1s.4 1 1 1M61 22.2H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1M61 39.8H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1M42.9 57.3H3c-.6 0-1 .4-1 1s.4 1 1 1h39.9c.6 0 1-.4 1-1s-.5-1-1-1" />
  </svg>
);
export default IconTextAlignJustifyCopy;
